import styled from 'styled-components';
import { Body1 } from '@common/components/Typography';

export const StyledBody = styled(Body1)`
  display: block;
  margin-top: ${({ theme }) => theme.spaces.space7};
`;
